module.exports = __webpack_public_path__ + "img/title5.bf6cc87d.png";